import auth from '../services/Auth'

export const userProfile = (state = auth.getProfile(), action) => {
  switch (action.type) {
    case 'SET_PROFILE':
      return action.userProfile;
    default:
      return state;
  }
};

export const getUserProfile = (state) => state;
